module.exports = __webpack_public_path__ + "media/img/Fill-2-green-7a983244.svg";